import { useState, useEffect } from "react";
import { createModel } from "hox";
import useStorageState from "@/hooks/useStorageState";
import { globalPrompt } from "@/components/message";
import { dictService } from "./dictService";
import { IDictDetail, IDictSearch } from "./dictTypes";
import { forFind } from "@/utils/utils";
// import { DictCodeE
import useGlobalModel from "@/model/globalModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";

type dictObj = {
    [key: string]: any
}
type ISelectOptions = {
    label: string,
    value: string,
    relationvalue?: string,//关联的Value值
}
export type ITreeSelectData = {
    title: string,
    value: string,
    children: ITreeSelectData[]
}
function listChangeTree(list: IDictDetail[]) {
    let menuObj: dictObj = {}
    list.forEach(item => {
        item.children = []
        menuObj[item.code as string] = item
    })
    return list.filter(item => {
        if (item.pcode !== null && item.pcode !== "") {
            menuObj[item.pcode as string]?.children.push(item)
            return false
        }
        return true
    })
}
function setTreePcode(array: IDictDetail[]) {
    array.forEach(item => {
        //有权限就设置为展示
        item.key = item.id as string;
    })
}
export const useDictModel = createModel(function () {
    const [treeSource, setTreeSource, clearTreeSource] = useStorageState<IDictDetail[]>("dictTree", []);  //字典数据源
    const [selectedNodes, setSelectedNodes] = useState<IDictDetail[]>([]);   //树选中的行信息
    const [mode, setMode] = useState<"add" | "edit" | "nextInsert" | "">("");
    const [formVal, setFormVal] = useState<IDictDetail>(selectedNodes[0]);  //表单缓存

    //实时缓存
    const onChangeFormVal = (changedValues: { [key: string]: any }) => {
        console.log(changedValues)
        setFormVal({ ...formVal, ...changedValues });
    }

    const initDictFormFields = {
        pcode: "",
        code: "",
        name: "",
        note: "",
        ver: 0,
        sourceAuthKey: "",
        children: [],
        status: 0,
        branch: "",
        value: "",
        key: ""
    }
    useEffect(() => {
        if (mode === "add") {
            console.log(selectedNodes[0])
            setFormVal({ ...selectedNodes[0], ...initDictFormFields, pcode: selectedNodes[0].pcode })
        } else if (mode === "nextInsert") {
            setFormVal({ ...selectedNodes[0], ...initDictFormFields, pcode: selectedNodes[0].code })
        }
    }, [mode])

    const loadData = async () => {
        let data: IDictSearch = {
            page: {
                pageSize: 10000000,
                pageNum: 1,
            }
        }
        let { retData } = await dictService.page(data);
        let { items } = retData;
        setTreePcode(items)
        setTreeSource(listChangeTree(items));
    }

    //表单提交
    const onSubmit = async () => {
        // return console.log(formVal)
        let { code, pcode, note, name, nameEn, status, value } = formVal;
        let data = {
            branch: "main",
            code, pcode, note, name, nameEn, value,
            status: status ? 1 : 0
        }
        if (!data.code) {
            globalPrompt("message", { text: "编码为必填项", type: "warning" });
            return;
        }
        if (mode === "add" || mode === "nextInsert") {
            let { retData } = await dictService.insert(data);
            retData && globalPrompt("message", { type: "success", text: "字典增加成功" });
            loadData();
            setSelectedNodes([]);
        } else if (mode === "edit") {
            let { retData } = await dictService.update({ ...data, id: selectedNodes[0].id });
            retData && globalPrompt("message", { type: "success", text: "字典编辑成功" });
            loadData();
            setSelectedNodes([]);
        }
    }
    //删除一条数据
    const removeOneDict = async (code: string) => {
        let { retData } = await dictService.delete(code);
        retData && globalPrompt("message", { type: "success", text: "字典删除成功" });

        loadData();
        setSelectedNodes([]);
    }

    //根据code返回 select框的options 格式；
    const getSelectedDictOne = (code: string): ISelectOptions[] => {
        let findTree: IDictDetail | undefined = forFind(treeSource, code, "code");
        return findTree ? findTree?.children.map(item => ({ label: item.name, value: item.code })) : []
    }

    //根据code 返回对应的node节点名称
    const getTreeNodeName = (code: string): string => {
        let obj: dictObj = {};
        let findTree: IDictDetail | undefined = forFind(treeSource, code, "code");
        return findTree ? findTree["name"] : "";
    }

    //根据code 返回对应树节点
    const getTreeNodeOne = (code: string): IDictDetail[] => {
        let findTree: IDictDetail | undefined = forFind(treeSource, code, "code");
        return findTree ? [findTree] : [];
    }

    const mapTree = (org: IDictDetail): ITreeSelectData => {
        const haveChildren = Array.isArray(org.children) && org.children.length > 0;
        return {
            title: org.name,
            value: org.code,
            //判断它是否存在子集，若果存在就进行再次进行遍历操作，知道不存在子集便对其他的元素进行操作
            children: haveChildren ? org.children.map(i => mapTree(i)) : []
        };
    }
    //根据code 返回treeSelect 数据格式
    const getTreeSelectOne = (code: DictCodeEnmu): ITreeSelectData[] => {
        let findTree: IDictDetail | undefined = forFind(treeSource, code, "code");
        return findTree ? mapTree(findTree).children : [];
    }
    return {
        /***field***/
        treeSource,
        selectedNodes,
        mode,
        formVal,
        /***method***/
        setTreeSource,
        setSelectedNodes,
        setMode,
        setFormVal,
        onChangeFormVal,
        loadData,
        onSubmit,
        getTreeNodeName,
        getSelectedDictOne,
        getTreeNodeOne,
        getTreeSelectOne,
    }
});